import React from "react";
import { languages } from "../../../constants/languages";
import { withTheme } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import DiaTextDialog from "../../../components/settings/slideshow/DiaTextDialog";
import TextIcon from "@material-ui/icons/Notes";

class DiaTextContainer extends React.Component {
  state = {
    dialogOpen: false,
    title: this.props.structureElement
      ? this.props.structureElement.textTitle || ""
      : "",
    text: this.props.structureElement
      ? this.props.structureElement.text || ""
      : "",
  };

  toggleDialog = () => {
    this.setState({ dialogOpen: !this.state.dialogOpen });
  };

  handleTitleChange = (e) => {
    this.setState({ title: e.target.value });
  };

  handleDiaTextChange = (e) => {
    let diaText = e.target.value.replace(/\n/g, "<br />");
    this.setState({ text: diaText });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.toggleDialog();
    let numInDia = null;
    let textNum = null;
    if (this.props.structureElement) {
      numInDia = this.props.structureElement.numInDia;
      textNum = this.props.structureElement.textNum;
    }

    if (numInDia === null) {
      numInDia = 0;
      if (this.props.structureElements.length > 0) {
        let lastElement =
          this.props.structureElements[
            this.props.structureElements.length - 1
          ] || {};
        numInDia =
          lastElement[
            lastElement.numInDiaLocal !== undefined
              ? "numInDiaLocal"
              : "numInDia"
          ] + 1;
      }
    }

    if (textNum === null) {
      ["", "1", "2", "3", "4", "5", "6", "7", "8"].reverse().forEach((x) => {
        if (
          this.props.dia["diaTextIndex" + x] === null ||
          this.props.dia["diaTextIndex" + x] === undefined
        ) {
          textNum = x;
        }
      });
    }

    if (textNum !== null) {
      let toUpdate = {};
      toUpdate["diaTextTitle" + textNum] = this.state.title;
      toUpdate["diaText" + textNum] = this.state.text;
      toUpdate["diaTextIndex" + textNum] = numInDia;
      window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("dias")
        .doc(this.props.dia.id)
        .update(toUpdate)
        .then(() => {
          if (!this.props.structureElement) {
            this.setState({ title: "", text: "" });
          }
        });
    }
  };

  render() {
    return (
      <div style={{ display: "inline-block" }}>
        <DiaTextDialog
          open={this.state.dialogOpen}
          diaText={this.state.text}
          diaTextTitle={this.state.title}
          toggleDialog={this.toggleDialog}
          handleDiaTextChange={this.handleDiaTextChange}
          handleDiaTextTitleChange={this.handleTitleChange}
          handleSubmit={this.handleSubmit}
        />

        <div>
          <div>
            {this.props.edit ? (
              <IconButton
                aria-label="Change"
                onClick={this.toggleDialog}
                style={{
                  height: 30,
                  width: 30,
                  marginLeft: 5,
                  marginRight: 5,
                  color: "gray",
                }}
              >
                <CreateIcon
                  style={{
                    height: 20,
                    width: 20,
                    position: "absolute",
                    top: 6,
                  }}
                />
              </IconButton>
            ) : (
              <Tooltip title={languages.present.text}>
                <IconButton onClick={this.toggleDialog} size="small">
                  <TextIcon style={{ height: 20, width: 20 }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTheme(DiaTextContainer);
